module.exports = __webpack_public_path__ + "static/media/trimex_fresa.944d8798.png";